import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  class: "chevron-left-right_svg__svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "m19.174 12.002-5.586-5.586 1.414-1.414 7 7-7 7-1.414-1.414 5.586-5.586ZM4.826 12.002l5.586-5.586-1.414-1.414-7 7 7 7 1.414-1.414-5.586-5.586Z"
    }, null, -1)
  ]))]))
}
export default { render: render }